// Tiny pub/sub so components can talk without prop-drilling
// Adapted from Karma AC v11

type EventCallback = (payload?: any) => void;

const listeners = new Map<string, Set<EventCallback>>();

export const eventBus = {
  on(event: string, cb: EventCallback): () => void {
    if (!listeners.has(event)) {
      listeners.set(event, new Set());
    }
    listeners.get(event)!.add(cb);
    return () => listeners.get(event)?.delete(cb);
  },
  
  emit(event: string, payload?: any): void {
    listeners.get(event)?.forEach(cb => cb(payload));
  },
  
  off(event: string, cb: EventCallback): void {
    listeners.get(event)?.delete(cb);
  },
  
  clear(event?: string): void {
    if (event) {
      listeners.delete(event);
    } else {
      listeners.clear();
    }
  }
};

